import { createAsyncAction } from 'src/redux/actions';

export const LoadProfilePage = createAsyncAction('profile/LOAD_PROFILE_PAGE');
